var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-overlay n-row" }, [
    _c(
      "div",
      {
        staticClass: "in-content",
        class: { clsng: _vm.Global.tempClosingOverlay },
      },
      [
        _c("div", { staticClass: "head" }, [
          _c(
            "h5",
            [
              _c("span", { staticClass: "txt-grt" }, [
                _vm._v(
                  _vm._s(_vm.Global.rowIdToEdit ? "Edit row" : "Add new row")
                ),
              ]),
              _vm._v(" "),
              !_vm.Global.rowIdToEdit ||
              !(_vm.currentStep == 2 && _vm.totalStep == 2)
                ? [
                    _vm.Global.rowIdToEdit
                      ? _c("span", { staticClass: "steps" }, [
                          _vm._v(
                            _vm._s(_vm.currentStep - 1) +
                              "/" +
                              _vm._s(_vm.totalStep - 1)
                          ),
                        ])
                      : _c("span", { staticClass: "steps" }, [
                          _vm._v(
                            _vm._s(_vm.currentStep) +
                              "/" +
                              _vm._s(_vm.totalStep)
                          ),
                        ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "x",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closeRowOverlay.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 22 22",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.4706 2.5L2.5 19.4706",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.4706 19.4706L2.5 2.5",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inner-content" },
          [
            _c(
              "transition",
              { attrs: { name: "fade", mode: "out-in" } },
              [
                _c(
                  "keep-alive",
                  { attrs: { max: "3" } },
                  [
                    _vm.currentStep == 1
                      ? _c("NewRowOne", {
                          on: {
                            rowType: _vm.rowTypeCheck,
                            nxt: function ($event) {
                              return _vm.goTo(2)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentStep == 2 && _vm.rowType == "auto"
                      ? _c("NewRowTwoAuto", {
                          on: {
                            prv: function ($event) {
                              return _vm.goTo(1)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentStep == 2 && _vm.rowType == "tag"
                      ? _c("NewRowTwoTag", {
                          on: {
                            prv: function ($event) {
                              return _vm.goTo(1)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentStep == 2 && _vm.rowType == "manual"
                      ? _c("NewRowTwoManual", {
                          on: {
                            prv: function ($event) {
                              return _vm.goTo(1)
                            },
                            nxt: function ($event) {
                              return _vm.goTo(3)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentStep == 3 && _vm.rowType == "manual"
                      ? _c("NewRowThreeManual", {
                          on: {
                            prv: function ($event) {
                              return _vm.goTo(2)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }